import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo, useState } from "react";
import { setTag } from "@sentry/nextjs";
import { analysisUserPropertyKeys, setAnalysisUserProperty } from "@/utils/analysis/analysis";
import { useStorage } from "./useStorage";

/**
 * LocalStorageに保存されているViewモードフラグを取得・更新するカスタムフック
 * ViewモードはView専用モードを切り替えるためのフラグ
 * @param initial - 初期値
 */
export const useViewModeFlg = () => {
  const $ = _c(7);
  const {
    value: viewModeFlg,
    write
  } = useStorage("viewModeFlg", "0", "local");
  const [isInitialized, setIsInitialized] = useState(false);
  const viewModeEnabled = viewModeFlg == null ? null : viewModeFlg === "1";
  let t0;
  let t1;
  if ($[0] !== viewModeFlg) {
    t0 = () => {
      if (viewModeFlg !== null) {
        setIsInitialized(true);
        setAnalysisUserProperty(analysisUserPropertyKeys.VIEW_MODE_ENABLED, viewModeFlg);
        setTag("viewModeFlg", viewModeFlg);
      }
    };
    t1 = [viewModeFlg];
    $[0] = viewModeFlg;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== isInitialized || $[4] !== viewModeEnabled || $[5] !== write) {
    t2 = {
      viewModeEnabled,
      write,
      isInitialized
    };
    $[3] = isInitialized;
    $[4] = viewModeEnabled;
    $[5] = write;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};